enum SearchByType {
    RefDataSourceName = 'Ref Data Source Name',
    FieldName = 'Report Field Name',
    VariableName = 'Variable Name',
    Id = 'Id',
    Name = 'Name'
}

export default SearchByType;
